import { GridComponent, ELoadingStatus } from './components/grid.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid';

import { 
  Component, 
  OnInit,
  OnChanges,
  OnDestroy,
  Input,
  Output,
  SimpleChanges,
  EventEmitter,
  TemplateRef,
  ViewChild,
  NgZone,
  Inject,
  forwardRef
} from '@angular/core';

import { isEqual, isNil, isEmpty, set } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil, mergeMap, shareReplay } from 'rxjs/operators';
import { BaseComponent } from './components/base.component';
import { SharedModule } from './shared.module';import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DatexFormControl, validateControlOnChange, validateFormOnControlChange } from './models/datex-form-control';
import { Styles, ControlContainerStyles } from './models/style';
import { FieldModel } from './models/field';
import { FieldsetModel } from './models/fieldset';
import { ToolModel } from './models/tool';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles,
  ValueControlModel
} from './models/control';
import { datCodeValidator } from './components/code-validator.directive';import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { Totes_ShellService } from './Totes.shell.service';
import { Totes_OperationService } from './Totes.operation.service';
import { Totes_DatasourceService } from './Totes.datasource.index';
import { Totes_FlowService } from './Totes.flow.index';
import { Totes_FrontendFlowService } from './Totes.frontend.flow.service';
import { Totes_ReportService } from './Totes.report.index';
import { Totes_LocalizationService } from './Totes.localization.service';
import { Totes_tote_container_statuses_grid_ComponentContextService } from './Totes.tote_container_statuses_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './Totes.frontend.types'
import { $frontendTypes as $types} from './Totes.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';


interface ITotes_tote_container_statuses_gridComponentEntity {
  Id?: number, Name?: string, SystemDefined?: boolean}



class Totes_tote_container_statuses_gridComponentRowModel extends GridRowModel {
  grid: Totes_tote_container_statuses_gridComponent;
  entity: ITotes_tote_container_statuses_gridComponentEntity;


  options: { delete_button: ButtonModel } = {
    delete_button: new ButtonModel('delete_button', new ButtonStyles(null, null), false, false, false, 'Delete', '', null)

  }

 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
    Name_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    system_defined_display: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
  });

  override cells = {
    Name: null,
    system_defined: null,
    id: null,
  }



  constructor(
    grid: Totes_tote_container_statuses_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: Totes_ShellService,
private $datasources: Totes_DatasourceService,
private $flows: Totes_FlowService,
private $frontendFlows: Totes_FrontendFlowService,
private $reports: Totes_ReportService,
private $localization: Totes_LocalizationService,
private $operations: Totes_OperationService,
private $logger: CleanupLoggerService,
private $context: Totes_tote_container_statuses_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Name,
      new TextModel(null, null, null, null, null)
,
      new TextBoxModel(this.formGroup.controls['Name_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    this.cells.system_defined = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.system_defined,
      new CheckBoxModel(this.formGroup.controls['system_defined_display'] as DatexFormControl, null, false, false, '', null)
,
null
      );
    
    this.cells.id = new GridCellModel(
      new CellStyles(['center'], null),
      this.grid.headers.id,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    
    this.formGroup
      .controls['Name_edit']
      .valueChanges
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_save();
      });
  }

  async $initializeExisting(entity: ITotes_tote_container_statuses_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.Id].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: ITotes_tote_container_statuses_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.Id].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = this.entity.Id;
    const $inParams: { $keys: number[] } = {
      $keys:[$resultKey],
    };
    const $data = await this.$datasources.Totes.ds_container_statuses.getByKeys($inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns($inParams, $data);
      
    this.entity = $data.result[0] as ITotes_tote_container_statuses_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.Name.displayControl as TextModel).text = $row.entity.Name;
    (this.cells.Name.editControl as TextBoxModel).reset($row.entity.Name);
    (this.cells.system_defined.displayControl as CheckBoxModel).reset($row.entity.SystemDefined);
    (this.cells.id.displayControl as TextModel).text = $row.entity.Id.toString();

    await this.on_row_data_loaded();
  }

  override async refresh() {
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
      await this.on_save();
      this.isNew = false;
    } else {
      await this.on_save();
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
    }
  }

  //#region private flows
  on_save(event = null) {
    return this.on_saveInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$frontendFlows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_saveInternal(
    $row: Totes_tote_container_statuses_gridComponentRowModel,
  $grid: Totes_tote_container_statuses_gridComponent, 
    $shell: Totes_ShellService,
    $datasources: Totes_DatasourceService,
    $flows: Totes_FlowService,
    $frontendFlows: Totes_FrontendFlowService,
    $reports: Totes_ReportService,
    $settings: SettingsValuesService,
    $operations: Totes_OperationService,
    $utils: UtilsService,
    $context: Totes_tote_container_statuses_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Totes_LocalizationService,
    $event: any
  ) {
    this.$logger.log('Totes', 'tote_container_statuses_grid.on_save');
  
  
  
  
  if ($row.cells.Name.editControl.isChanged && $utils.isDefined($row.entity.Id)) {
      await $flows.Totes.create_delete_or_update_container_statuses({ statusId: $row.entity.Id, status_name: $row.cells.Name.editControl.value, action: 'UPDATE' })
  } else if ($row.cells.Name.editControl.isChanged && !$utils.isDefined($row.entity.Id)) {
      await $flows.Totes.create_delete_or_update_container_statuses({ status_name: $row.cells.Name.editControl.value, action: 'CREATE' })
  
  } else {
      $shell.Totes.openErrorDialog('Error saving status', 'Status not recognized')
  }
  
  
  await $grid.refresh()
  }
  on_delete_clicked(event = null) {
    return this.on_delete_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$frontendFlows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_delete_clickedInternal(
    $row: Totes_tote_container_statuses_gridComponentRowModel,
  $grid: Totes_tote_container_statuses_gridComponent, 
    $shell: Totes_ShellService,
    $datasources: Totes_DatasourceService,
    $flows: Totes_FlowService,
    $frontendFlows: Totes_FrontendFlowService,
    $reports: Totes_ReportService,
    $settings: SettingsValuesService,
    $operations: Totes_OperationService,
    $utils: UtilsService,
    $context: Totes_tote_container_statuses_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Totes_LocalizationService,
    $event: any
  ) {
    this.$logger.log('Totes', 'tote_container_statuses_grid.on_delete_clicked');
  
  
  
  let deleted = (await $flows.Totes.create_delete_or_update_container_statuses({action: 'DELETE', statusId: $row.entity.Id}))
  
  await $grid.refresh()
  }
  on_row_data_loaded(event = null) {
    return this.on_row_data_loadedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$frontendFlows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_data_loadedInternal(
    $row: Totes_tote_container_statuses_gridComponentRowModel,
  $grid: Totes_tote_container_statuses_gridComponent, 
    $shell: Totes_ShellService,
    $datasources: Totes_DatasourceService,
    $flows: Totes_FlowService,
    $frontendFlows: Totes_FrontendFlowService,
    $reports: Totes_ReportService,
    $settings: SettingsValuesService,
    $operations: Totes_OperationService,
    $utils: UtilsService,
    $context: Totes_tote_container_statuses_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Totes_LocalizationService,
    $event: any
  ) {
    this.$logger.log('Totes', 'tote_container_statuses_grid.on_row_data_loaded');
  if($row.entity.SystemDefined){
      $row.cells.Name.editControl.readOnly = true
      $row.options.delete_button.readOnly = true
  }
  }
  //#endregion private flows

}


@Component({
  imports: [
    SharedModule,
  ],
  selector: 'Totes-tote_container_statuses_grid',
  templateUrl: './Totes.tote_container_statuses_grid.component.html'
})
export class Totes_tote_container_statuses_gridComponent extends BaseComponent implements OnInit, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: ITotes_tote_container_statuses_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;

canEdit: boolean = true;
// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
canAdd: boolean = true; 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['default','fit-content-table']);

  fullTextSearch: string;



  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     Name: new GridHeaderModel(new HeaderStyles(null, null), 'Name', 'Name', false, false, null, false),       system_defined: new GridHeaderModel(new HeaderStyles(null, null), 'system_defined', 'System defined', false, false, null, false),       id: new GridHeaderModel(new HeaderStyles(['center'], null), 'id', 'Id', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: Totes_tote_container_statuses_gridComponentRowModel[] = [];


  topToolbar = {
  };

  bottomToolbar = {
    addLine : new ToolModel(new ButtonModel(null, null, false, false, false, 'Add row', 'icon-ic_fluent_add_circle_20_regular')),
  };




  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: Totes_ShellService,
    private $datasources: Totes_DatasourceService,
    private $flows: Totes_FlowService,
    private $frontendFlows: Totes_FrontendFlowService,
    private $reports: Totes_ReportService,
    private $localization: Totes_LocalizationService,
    private $operations: Totes_OperationService,
    private $logger: CleanupLoggerService,
    private $context: Totes_tote_container_statuses_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Tote container statuses';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  


  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 10;


    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    const $grid = this;
    const $utils = this.$utils;
    const $inParams: { $top?: number, $skip?: number } = {
      $top: this.pageSize,
      $skip: this.pageSkip,
    };
    try {
      const $data = await this.$datasources.Totes.ds_container_statuses.getList($inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns($inParams, $data);

      this.entities = $data.result as ITotes_tote_container_statuses_gridComponentEntity[];
      this.totalCount = $data.totalCount;

      await this.$dataLoaded();
      
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new Totes_tote_container_statuses_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$frontendFlows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

  }

  
    async $applyLinkedDatasourcesAndCustomColumns($inParams: any, $outParams: any) {
      const $datasource = { inParams: $inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }


  async addRow(entity?: ITotes_tote_container_statuses_gridComponentEntity) {
    const row = new Totes_tote_container_statuses_gridComponentRowModel(
      this,
      this.$utils,
      this.$settings,
      this.$shell, 
      this.$datasources,
      this.$flows,
      this.$frontendFlows,
      this.$reports,
      this.$localization,
      this.$operations,
      this.$logger,
      this.$context);
    await row.$initializeNew(entity);
    this.rows.push(row);
    row.setEditMode();
    return row;
  }
  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }



 
  close() {
    this.$finish.emit();
  }
}
